/**
 * ServerError — placeholder F2 para ErrorBoundary global.
 * F3 monta este componente como fallback. F8 puede enriquecer con telemetria
 * (Sentry/PostHog) y reporte estructurado al admin.
 */
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { EstrellaIcon } from '../components/icons';
import { Routes } from '../lib/routes';

export interface ServerErrorProps {
  /** Error capturado por el ErrorBoundary. Solo se muestra en DEV. */
  error?: Error;
  /** Callback para reintentar (provee el ErrorBoundary). */
  onReset?: () => void;
}

export function ServerError({ error, onReset }: ServerErrorProps) {
  // El detalle tecnico SOLO se renderiza en desarrollo para no filtrar
  // stack/trazas a usuarios finales.
  const showDevDetail = Boolean(error?.message) && import.meta.env.DEV;

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-100 px-4 py-12">
      <div className="flex flex-col items-center text-center max-w-xl gap-6">
        <EstrellaIcon size={96} className="text-error" />

        <div className="flex flex-col gap-3">
          <h1 className="text-h1 font-display text-error">
            Algo no salio como esperabamos
          </h1>
          <p className="text-body text-primary-900/70">
            Tuvimos un problema procesando tu solicitud. Si el error persiste,
            por favor contactanos para resolverlo.
          </p>
        </div>

        {/* F8.2 a11y: stacktrace dev en `primary-900/70` para pasar AA sobre cream. */}
        {showDevDetail && (
          <pre
            className="w-full max-w-lg text-left text-caption text-primary-900/70 bg-cream-50 border border-cream-200 rounded-md p-3 overflow-auto"
            aria-label="Detalle tecnico (solo desarrollo)"
          >
            {error?.message}
          </pre>
        )}

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-2">
          {onReset && (
            <Button variant="primary" onClick={onReset}>
              Intentar de nuevo
            </Button>
          )}
          {/* Altura >= 44px para alinear con touch target del Button primary. */}
          <Link
            to={Routes.home}
            className="inline-flex items-center justify-center h-11 px-4 rounded-md border border-primary-700 text-primary-700 font-body uppercase tracking-[0.04em] text-button hover:bg-primary-700 hover:text-cream-50 transition-colors duration-2 ease-out"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
